import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { IonContent, PopoverController } from '@ionic/angular';
import { Page } from 'src/app/models/page.model';
import { Subscription, Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverComponent } from 'src/app/shared/components/popover/popover.component';
import { SearchpopoverComponent } from 'src/app/shared/components/searchpopover/searchpopover.component';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.page.html',
  styleUrls: ['./categories.page.scss'],
})
export class CategoriesPage implements OnInit {
  @ViewChild('focusconDescription', { static: false }) focusconDescription;
  @ViewChild('table') table: DatatableComponent;
  @ViewChild('content') private content: IonContent;

  rows = [];
  page = new Page();

  skip: number = 0;
  pageSize: number = 20;
  count: any;

  faqId: string = ''
  itemsSelected: any = [];
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;

  editing = {};
  showPage: boolean = false;

  columnsWidth: any = [];
  deleteCount: any = [];;
  invalidSettingValue: boolean = false;
  invalidSettingName: boolean = false;

  adjustColumnWidth() {
    if (this.table && window.innerWidth > 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.Description = (50 / 100) * tableWidth;
    }
    if (this.table && window.innerWidth < 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.Description = (50 / 100) * tableWidth;
    }
  }

  constructor(private router: Router, private route: ActivatedRoute, private _apiService: ApiService, public _commonService: CommonService, private popoverController: PopoverController) {
    this.searchEvent = this._commonService.searchTextValue;
    this.page.pageNumber = 0;
    this.page.size = 20;

  }

  ngOnInit() {

  }

  ionViewDidLeave() {
    this.itemsSelected = [];
    // this.table.selected = [];
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  ionViewDidEnter() {
    this.itemsSelected = []
    this.faqId = this.route.snapshot.paramMap.get('id');

    this.itemsSelected = [];
    this.adjustColumnWidth();
    if (this.searchEvent) {
      this.searchSubscription = this.searchEvent.subscribe(event => {
        this.setPage({ offset: 0 }, event);
        this._commonService.searchText = event;
      });
    }
    this.setPage({ offset: this._commonService.currentPage ? this._commonService.currentPage : 0 }, this._commonService.searchText && this._commonService.searchText != '' ? this._commonService.searchText : '');
    this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
      setTimeout(() => {
        this.rows = [...this.rows];
        if (this.table) this.table.recalculate();
      }, 0)
    });
    this.resizeSubscription = this._commonService.onResize.subscribe(event => {
      this.adjustColumnWidth();
    });

  }

  /**
  * Populate the table with new data based on the page number
  * @param page The page to select
  */
  async setPage(pageInfo, searchText) {
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    this.page.pageNumber = pageInfo.offset;
    this.table.offset = this.page.pageNumber;
    this._apiService.getCategories(searchText ? searchText : '', this.page.orderBy, this.page.orderDir, 1, 0).then(data => {
      this.rows = data.body;

      this.page.totalElements = data.headers.get('X-Page-TotalCount')
      this.showPage = true;
      this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.table.selected = [];
      if (!this.table.element.className.includes("border-header")) this.table.element.className += " border-header";
      this.rows = data.body;
      this._commonService.log(this.rows, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }

  onSelect(event) {
    let selected = []
    if (event.selected) {

      event.selected.forEach(element => {
        if(element.CategoryId && element.CategoryId != "empty"){
          selected.push(element.CategoryId);
        } else{
          element.CategoryId = "empty"
          selected.push(element.CategoryId);
        }
      });
      this.itemsSelected = selected;
      this.deleteCount = this.itemsSelected.filter(e => e != 'empty');

    }
  }

  public onLimitChange(limit: any): void {
    this.page.size = parseInt(limit, 10);
    if (this._commonService.searchText && this._commonService.searchText != '') {
      this.setPage({ offset: 0 }, this._commonService.searchText);
    } else {
      this.setPage({ offset: 0 }, '');
    }
  }

  async onChangePage(pageData) {
    this.skip = pageData.skip;
    this.pageSize = pageData.pageSize;
    this.setPage(this.pageSize, '');
  }

  async presentPopover(event: any) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: { route: "domains/0", itemsSelected: this.itemsSelected, deleteRoute: "Domains" },
      event: event,
      showBackdrop: false,
      cssClass: 'popPopOver',
      translucent: true
    });
    return await popover.present();

  }

  async presentSearchPopover(event: any) {
    const popover = await this.popoverController.create({
      component: SearchpopoverComponent,
      event: event,
      translucent: false,
      cssClass: 'searchPopOver'
    });
    return await popover.present();
  }

  updateValue(event, rowIndex, row) {
    if (event.target.value != "") {
      this.editing[rowIndex] = false;
      this.rows[rowIndex].Description = event.target.value;
      this.rows = [...this.rows.map(element => {
        return {
          'CategoryId': element.CategoryId,
          'Description': element.Description,
        }
      })];
    }
  }
  focusAndEdit(rowIndex) {
    this.editing[rowIndex] = true;
    setTimeout(() => {
        this.focusconDescription.setFocus();
    }, 0);
  }
  goBack() {
    this.router.navigate(['maintenance/frequentlyaskedquestions/' + sessionStorage.faqId], { replaceUrl: true })
  }

  add() {
    this.rows.push({
      Description: "",
      CategoryId: null,
    })
    this.rows = [...this.rows];
    this.editing[this.table.rowCount] = true;
    setTimeout(() => {
      this.table.element.querySelector('.datatable-body').scrollTop = (this.rows.length + 1) * 50;
      if(this.table._internalRows[(this.rows.length-1)].Description == "") {
        this.focusconDescription.setFocus();
      }
    }, 0);
  }

  async onSubmit() {
    this._commonService.presentLoading();
    try {
      let data = [];
      this.rows.forEach(row => {
        if (row.Description && row.Description != "") {
          row.Description = row.Description.trim();
          data.push(row);
        }
      });

      this._commonService.log(data, this._commonService.LOG);
      await this._apiService.postCategory(data);
      this._commonService.dismiss();
      this.setPage({ offset: 0 }, "");
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          this.itemsSelected.forEach(async (element) => {
            if (element == "empty") {
              // let a=this.rows.slice(-1);
              this.itemsSelected = this.itemsSelected.filter(e => e != "empty");
              if(this.deleteCount.length == 0){
                this._commonService.dismiss();
              this.rows = this.rows.filter(e => e.CategoryId != "empty");
              }
            }
          });
          if (this.itemsSelected.length > 0) {
            await this._apiService.deleteCategories(this.itemsSelected);
            this._commonService.log(res, this._commonService.LOG);
            this._commonService.dismiss();
            this.table.selected = [];
            this.itemsSelected = [];
            this.setPage({ offset: 0 }, '');
          }
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  async onSort(event) {
    const sort = event.sorts[0];
    this.page.orderBy = sort.prop.toLowerCase();
    this.page.orderDir = sort.dir;
    this.setPage({ offset: this.page.pageNumber }, '');
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "add":
        this.add();
        break;
      case "delete":
        this.delete();
        break;
      case "search":
        this.itemsSelected=[];
        this.setPage({ offset: 0 }, obj.Event);
        break;
        case "close":
        this.itemsSelected=[];
        this.setPage({ offset: 0 }, "");
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true });
        break;
      case "back":
        this.goBack();
        break;
    }
  }

}
